import { render, staticRenderFns } from "./TechnicalInformation.vue?vue&type=template&id=1ac22476"
import script from "./TechnicalInformation.vue?vue&type=script&lang=js"
export * from "./TechnicalInformation.vue?vue&type=script&lang=js"
import style0 from "./TechnicalInformation.vue?vue&type=style&index=0&id=1ac22476&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports